

import { isMobileDevice } from "@/utils/index";
import Header from "../src/components/Header.vue";
import { LiveChatWidget } from '@livechat/widget-vue'

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
    };
  },
  components: { Header,LiveChatWidget },
};
